// src/components/ui/Appbar.tsx
import React from "react";
import { AppBar, Tabs, Tab } from "@mui/material";

export interface AppbarTab {
  label: string;
  value: number | string;
}

interface Props {
  tabs: AppbarTab[];
  value: string | number; // controlled
  onChange: (_: any, value: any) => void; // controlled
  primaryColor?: string; // AppBar background
  textColor?: string; // Tab text color (normal + selected)
  activeBarColor?: string; // Tab indicator color
  indicatorHeight?: number;
  tabPaddingX?: number | string;
}

const Appbar: React.FC<Props> = ({
  tabs,
  value,
  onChange,
  primaryColor = "#1976d2",
  textColor = "#ffffff",
  activeBarColor = "#ffffff",
  indicatorHeight = 3,
  tabPaddingX = 2,
}) => {
  const handleChange = (_e: React.SyntheticEvent, newValue: string) => {
    onChange(_e, newValue);
  };

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{ bgcolor: primaryColor, borderRadius: "4px !important" }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        TabIndicatorProps={{
          sx: {
            backgroundColor: activeBarColor,
            height: indicatorHeight,
            borderRadius: 0,
          },
        }}
        sx={{
          minHeight: 48,
          "& .MuiTab-root": {
            marginLeft:1,
            minHeight: 48,
            color: textColor,
            px: tabPaddingX,
            textTransform: "none",
            fontWeight: 500,
            opacity: 0.9,
            borderRadius: 10,
          },

          "& .MuiTab-root.Mui-selected": {
            color: textColor,
            opacity: 1,
          },
        }}
      >
        {tabs.map((t) => (
          <Tab key={t.value} value={t.value} label={t.label} />
        ))}
      </Tabs>
    </AppBar>
  );
};

export default Appbar;
